<template>
  <div>
    <router-view></router-view>
    <PageHeaderLayout v-show="this.$route.matched.length==2">
      <div class="main-page-content">
        <!-- 页面标题区域 -->
        <div class="page-title-section">
          <div class="title-content">
            <h1 class="page-title">
              <i class="el-icon-s-order"></i>
              订单管理
            </h1>
            <p class="page-subtitle">管理客户订单信息，查看订单状态和处理流程</p>
          </div>
        </div>

        <!-- 操作面板 -->
        <div class="action-card">
          <div class="action-buttons">
            <el-button type="warning" size="mini" icon="el-icon-s-shop" @click="openAdminCreateDialog()">代建订单</el-button>
            <el-button type="success" size="mini" icon="el-icon-download" @click="downloadButton()">导出订单</el-button>
            <el-button type="primary" size="mini" icon="el-icon-refresh" :loading="syncPayLoading" @click="batchSyncPaymentStatus()">批量查询支付状态</el-button>
            <el-button size="mini" icon="el-icon-message" @click="openMailStatusConfig">流转邮件配置</el-button>
          </div>
        </div>

        <!-- 搜索筛选卡片 -->
        <div class="search-card">
          <div class="search-header">
            <i class="el-icon-search"></i>
            <span>筛选条件</span>
          </div>
          <div class="search-content">
            <el-form size="mini" :inline="true" :model="searchCondition" class="search-form">
              <el-form-item label="订单ID">
                <el-input v-model="searchCondition.order_id" placeholder="精确匹配 UUID" clearable prefix-icon="el-icon-key">
                </el-input>
              </el-form-item>
              <el-form-item label="订单编号">
                <el-input v-model="searchCondition.order_no" placeholder="模糊匹配订单编号" clearable prefix-icon="el-icon-document">
                </el-input>
              </el-form-item>
              <el-form-item label="商户/交易号">
                <el-input
                  v-model="searchCondition.merchant_or_trade_no"
                  placeholder="支持商户订单号或交易号，如 1012604271826888800"
                  clearable
                  prefix-icon="el-icon-connection"
                />
              </el-form-item>
              <el-form-item>
                <el-select v-model="searchCondition.order_status" placeholder="订单状态" clearable>
                  <el-option label="未处理" value="0"></el-option>
                  <el-option label="用户确认" value="1"></el-option>
                  <el-option label="商户确定" value="2"></el-option>
                  <el-option label="生产" value="3"></el-option>
                  <el-option label="质检" value="4"></el-option>
                  <el-option label="发货" value="5"></el-option>
                  <el-option label="签收成功" value="6"></el-option>
                  <el-option label="历史状态(旧码7)" value="7"></el-option>
                  <el-option label="删除订单" value="8"></el-option>
                  <el-option label="取消订单" value="9"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model="searchCondition.pay_method" placeholder="支付方式" clearable>
                  <el-option v-for="o in payMethodFilterOptions" :key="o.value" :label="o.label" :value="o.value" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model="searchCondition.pay_status" placeholder="支付状态" clearable>
                  <el-option label="未支付" value="1"></el-option>
                  <el-option label="已支付" value="2"></el-option>
                  <el-option label="退款成功" value="4"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model="searchCondition.refund_approve_status" placeholder="退款审批" clearable>
                  <el-option label="待审退款" value="2"></el-option>
                  <el-option label="已开放申请" value="1"></el-option>
                  <el-option label="已审批通过" value="3"></el-option>
                  <el-option label="网关执行中" value="5"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="warning" size="mini" plain @click="quickPendingRefund">待审退款</el-button>
              </el-form-item>
              <el-form-item>
                <el-select v-model="searchCondition.order_craft_type" placeholder="报价类型" clearable>
                  <el-option label="自动报价" value="1"></el-option>
                  <el-option label="手动报价" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="mini" icon="el-icon-search" @click="searchButton">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-checkbox v-model="searchCondition.only_pending_sync">仅显示待支付可查单</el-checkbox>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <!-- 表格卡片 -->
        <div class="table-card">
          <ApeTable ref="apeTable" :data="dataList" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
            <el-table-column width="60" label="序号" align="center">
              <template slot-scope="scope">
                <span class="sequence-number">{{offset+scope.$index+1}}</span>
              </template>
            </el-table-column>
            
            <el-table-column label="订单信息" min-width="200">
              <template slot-scope="scope">
                <div class="order-info">
                  <div class="info-row">
                    <i class="el-icon-document"></i>
                    <span class="info-label">订单ID：</span>
                    <span class="info-value order-no">{{scope.row.id}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-document"></i>
                    <span class="info-label">订单编号：</span>
                    <span class="info-value order-no">{{scope.row.order_no}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-message"></i>
                    <span class="info-label">下单邮箱：</span>
                    <span class="info-value">{{getOrderCustomerEmail(scope.row)}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-s-custom"></i>
                    <span class="info-label">所在分组：</span>
                    <span class="info-value">{{getOrderCustomerGroupNames(scope.row)}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-time"></i>
                    <span class="info-label">最后上线：</span>
                    <span class="info-value">{{getOrderCustomerLastOnline(scope.row)}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-s-flag"></i>
                    <span class="info-label">订单状态：</span>
                    <el-tag :type="getOrderStatusType(scope.row.order_status)" size="mini">
                      {{getOrderStatusText(scope.row.order_status)}}
                    </el-tag>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-money"></i>
                    <span class="info-label">支付状态：</span>
                    <el-tag :type="getPayStatusType(scope.row.pay_status)" size="mini">
                      {{getPayStatusText(scope.row.pay_status)}}
                    </el-tag>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-price-tag"></i>
                    <span class="info-label">报价类型：</span>
                    <el-tag :type="getOrderCraftTypeTagType(scope.row.order_craft_type)" size="mini">
                      {{getOrderCraftTypeText(scope.row.order_craft_type)}}
                    </el-tag>
                  </div>
                  <div class="info-row" v-if="scope.row.pay_method">
                    <i class="el-icon-bank-card"></i>
                    <span class="info-label">支付方式：</span>
                    <el-tag :type="getPayMethodType(scope.row.pay_method)" size="mini">
                      {{getPayMethodText(scope.row.pay_method)}}
                    </el-tag>
                  </div>
                  <div class="info-row" v-if="isBankPayMethod(scope.row.pay_method)">
                    <i class="el-icon-document-checked"></i>
                    <span class="info-label">转账凭证：</span>
                    <el-link v-if="scope.row.bank_voucher_url" type="primary" :href="scope.row.bank_voucher_url" target="_blank">查看凭证</el-link>
                    <span class="info-value" v-else>未上传</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-s-operation"></i>
                    <span class="info-label">订单流转：</span>
                    <el-button 
                      type="text" 
                      size="mini" 
                      class="flow-button"
                      @click="showOrderFlow(scope.row)"
                    >
                      <i class="el-icon-view"></i>
                      查看流转详情
                    </el-button>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="收件信息" min-width="180">
              <template slot-scope="scope">
                <div class="address-info">
                  <div class="info-row">
                    <i class="el-icon-user"></i>
                    <span class="info-label">联系人：</span>
                    <span class="info-value">
                      {{(scope.row.Address && scope.row.Address.first_name) || (scope.row.Customer && scope.row.Customer.firstName) || '未知'}} 
                      {{(scope.row.Address && scope.row.Address.last_name) || (scope.row.Customer && scope.row.Customer.lastName) || ''}}
                    </span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-phone"></i>
                    <span class="info-label">电话：</span>
                    <span class="info-value">{{(scope.row.Address && scope.row.Address.phone_number) || (scope.row.Customer && scope.row.Customer.mobile) || '暂无'}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-location"></i>
                    <span class="info-label">地址：</span>
                    <span class="info-value address">
                      {{(scope.row.Address && scope.row.Address.country) || (scope.row.Customer && scope.row.Customer.country) || ''}} 
                      {{scope.row.Address && scope.row.Address.state || ''}} 
                      {{scope.row.Address && scope.row.Address.city || ''}} 
                      {{scope.row.Address && scope.row.Address.address || ''}}
                    </span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-truck"></i>
                    <span class="info-label">快递：</span>
                    <span class="info-value">{{(scope.row.Express && scope.row.Express.express_name) || scope.row.express_name || '暂无'}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-document"></i>
                    <span class="info-label">到付账号：</span>
                    <span class="info-value">{{ scope.row.express_account || '暂无' }}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-collection-tag"></i>
                    <span class="info-label">快递单号：</span>
                    <span class="info-value">{{scope.row.express_no || '暂无'}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-coin"></i>
                    <span class="info-label">快递费：</span>
                    <span class="info-value price">{{scope.row.currency}}{{scope.row.logistic_price}}</span>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="模型/工艺" min-width="200" show-overflow-tooltip>
              <template slot-scope="scope">
                <div v-if="orderLineItems(scope.row).length" class="line-items-preview">
                  <div
                    v-for="(it, idx) in orderLineItems(scope.row)"
                    :key="it.id || idx"
                    class="line-item-row"
                  >
                    <span class="line-item-label">#{{ idx + 1 }}</span>
                    <span class="line-item-text">{{ orderItemFileName(it) }} · {{ orderItemCraftName(it) }}<template v-if="orderItemCraftCategoryTitle(it)"> · {{ orderItemCraftCategoryTitle(it) }}</template></span>
                  </div>
                </div>
                <span v-else class="info-value muted">暂无行项目</span>
              </template>
            </el-table-column>

            <el-table-column label="金额信息" min-width="160">
              <template slot-scope="scope">
                <div class="amount-info">
                  <div class="info-row">
                    <i class="el-icon-money"></i>
                    <span class="info-label">币种：</span>
                    <el-tag type="info" size="mini">{{scope.row.currency}}</el-tag>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-s-finance"></i>
                    <span class="info-label">订单总额（含运费）：</span>
                    <span class="info-value total-price">{{scope.row.currency}}{{scope.row.total_price}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-wallet"></i>
                    <span class="info-label">已付金额：</span>
                    <span class="info-value paid-price">{{scope.row.currency}}{{scope.row.pay_amount}}</span>
                  </div>
                  <div class="info-row" v-if="getTradeNo(scope.row)">
                    <i class="el-icon-document"></i>
                    <span class="info-label">交易流水号：</span>
                    <span class="info-value">{{ getTradeNo(scope.row) }}</span>
                  </div>
                  <div class="info-row" v-if="getMerchantOrderNo(scope.row)">
                    <i class="el-icon-tickets"></i>
                    <span class="info-label">商户订单号：</span>
                    <span class="info-value">{{ getMerchantOrderNo(scope.row) }}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-discount"></i>
                    <span class="info-label">折扣：</span>
                    <el-tag type="success" size="mini">{{scope.row.discount}}%</el-tag>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-edit-outline"></i>
                    <span class="info-label">备注：</span>
                    <span class="info-value remark">{{scope.row.mark || '无'}}</span>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column min-width="160">
              <template slot="header">
                <span class="sortable-order-time-header" title="点击按下单时间排序" @click="toggleOrderTimeSort">
                  时间信息
                  <i :class="orderTimeSort === 'desc' ? 'el-icon-sort-down' : 'el-icon-sort-up'"></i>
                </span>
              </template>
              <template slot-scope="scope">
                <div class="time-info">
                  <div class="info-row">
                    <i class="el-icon-time"></i>
                    <span class="info-label">下单时间：</span>
                    <span class="info-value">{{formatDateTime(scope.row.order_time)}}</span>
                  </div>
                  <div class="info-row" v-if="scope.row.pay_time">
                    <i class="el-icon-success"></i>
                    <span class="info-label">支付时间：</span>
                    <span class="info-value">{{formatDateTime(scope.row.pay_time)}}</span>
                  </div>
                  <div class="info-row" v-if="scope.row.deliver_time">
                    <i class="el-icon-truck"></i>
                    <span class="info-label">发货时间：</span>
                    <span class="info-value">{{formatDateTime(scope.row.deliver_time)}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-refresh"></i>
                    <span class="info-label">更新时间：</span>
                    <span class="info-value">{{formatDateTime(scope.row.updated_at)}}</span>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column v-if="buttonType=='icon'" width="230" label="操作" align="center">
              <template slot-scope="scope">
                <div class="action-buttons">
                  <el-tooltip v-if="canManualQuote(scope.row)" effect="dark" content="报价" placement="top">
                    <el-button size="mini" icon="el-icon-money" circle type="danger" @click="openQuoteDialog(scope.row)"></el-button>
                  </el-tooltip>
                  <el-tooltip v-if="canReprice(scope.row)" effect="dark" content="改价（未付款订单）" placement="top">
                    <el-button size="mini" icon="el-icon-edit" circle type="danger" @click="openRepriceDialog(scope.row)"></el-button>
                  </el-tooltip>
                  <el-tooltip v-if="canCopyPayLink(scope.row)" effect="dark" content="复制付款链接" placement="top">
                    <el-button size="mini" icon="el-icon-link" circle type="info" @click="copyPayLink(scope.row)"></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="形式发票PDF" placement="top">
                    <el-button
                      size="mini"
                      icon="el-icon-document"
                      circle
                      type="success"
                      :loading="scope.row._invoice === true"
                      @click="downloadInvoice(scope.row)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="订单跟进" placement="top">
                    <el-button size="mini" icon="el-icon-view" circle type="primary" @click="followButton(scope.row.id)"></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="查询支付状态" placement="top">
                    <el-button
                      size="mini"
                      icon="el-icon-refresh"
                      circle
                      type="warning"
                      :loading="scope.row._syncing === true"
                      @click="syncOneOrderPaymentStatus(scope.row)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="订单详情" placement="top">
                    <el-button size="mini" icon="el-icon-s-order" circle type="success" @click="getCustomerOrderItem(scope.row.order_no)"></el-button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>

    <ApeDrawer :drawerData="drawerData" @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <el-form :model="formData" :rules="rules" ref="userForm" label-position="right" label-width="96px">
          <el-row>
            <el-col :span="22">
              <el-form-item label="订单名称" prop="department_name">
                <el-input v-model="formData.department_name" prefix-icon="el-icon-edit-outline"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="订单描述" prop="department_desc">
                <el-input v-model="formData.department_desc" type="textarea" :rows="3"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>     
      </template>
    </ApeDrawer>

    <!-- 订单流转详情对话框 -->
    <el-dialog
      :title="orderFlowDialog.title"
      :visible.sync="orderFlowDialog.visible"
      width="90vw"
      :style="{ maxWidth: '800px', minWidth: '320px', borderRadius: '16px', margin: '0 auto' }"
      @close="closeOrderFlowDialog"
      class="order-flow-dialog"
      append-to-body
      center
    >
      <div class="order-flow-content" v-loading="orderFlowDialog.loading">
        <!-- 订单基本信息卡片 -->
        <div class="flow-order-info card-block">
          <div class="info-header">
            <i class="el-icon-s-order"></i>
            <span>订单基本信息</span>
          </div>
          <div class="info-content">
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="info-item">
                  <span class="label">订单编号：</span>
                  <span class="value">{{orderFlowDialog.orderInfo.order_no}}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <span class="label">当前状态：</span>
                  <el-tag :type="getOrderStatusType(orderFlowDialog.orderInfo.order_status)" size="medium">
                    {{getOrderStatusText(orderFlowDialog.orderInfo.order_status)}}
                  </el-tag>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <span class="label">支付状态：</span>
                  <el-tag :type="getPayStatusType(orderFlowDialog.orderInfo.pay_status)" size="medium">
                    {{getPayStatusText(orderFlowDialog.orderInfo.pay_status)}}
                  </el-tag>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="info-item">
                  <span class="label">订单总额：</span>
                  <span class="value price">{{orderFlowDialog.orderInfo.currency}}{{orderFlowDialog.orderInfo.total_price}}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <span class="label">下单时间：</span>
                  <span class="value">{{formatDateTime(orderFlowDialog.orderInfo.order_time)}}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <span class="label">更新时间：</span>
                  <span class="value">{{formatDateTime(orderFlowDialog.orderInfo.updated_at)}}</span>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 流转记录卡片 -->
        <div class="flow-records card-block">
          <div class="records-header">
            <i class="el-icon-time"></i>
            <span>流转记录</span>
          </div>
          <div class="records-content">
            <el-timeline v-if="orderFlowDialog.flowRecords.length">
              <el-timeline-item
                v-for="record in orderFlowDialog.flowRecords"
                :key="record.id"
                :timestamp="formatDateTime(record.operate_time)"
                :type="getTimelineType(record.status)"
                :icon="getTimelineIcon(record.status)"
                class="timeline-item-block"
              >
                <div class="record-item">
                  <div class="record-header">
                    <el-tag :type="getOrderStatusType(record.status)" size="mini">
                      {{record.status_name}}
                    </el-tag>
                    <span class="operator">操作人：{{record.operator}}</span>
                  </div>
                  <div class="record-content">
                    <p class="record-remark">{{record.remark}}</p>
                    <!-- 变更详情高亮展示（如有） -->
                    <div v-if="record.change_details" class="change-details">
                      <div v-for="(change, fieldName) in record.change_details" :key="fieldName" class="change-item">
                        <span class="change-field"><el-tag size="mini" type="info">{{getFieldLabel(fieldName)}}</el-tag>：</span>
                        <span class="change-from">{{formatChangeValue(change.from, fieldName)}}</span>
                        <i class="el-icon-arrow-right"></i>
                        <span class="change-to">{{formatChangeValue(change.to, fieldName)}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="record-footer">
                    <span class="footer-time">{{formatDateTime(record.operate_time)}}</span>
                  </div>
                </div>
              </el-timeline-item>
            </el-timeline>
            <div v-else class="no-records-tip">
              <i class="el-icon-info"></i> 暂无流转记录
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeOrderFlowDialog">关闭</el-button>
        <el-button type="primary" @click="followButton(orderFlowDialog.orderInfo.id)">
          <i class="el-icon-edit"></i>
          订单跟进
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="手动报价"
      :visible.sync="quoteDialog.visible"
      width="92vw"
      top="4vh"
      :close-on-click-modal="false"
      append-to-body
      class="manual-quote-dialog"
      @close="closeQuoteDialog"
    >
      <div v-loading="quoteDialog.loading">
        <div v-if="quoteDialog.row" class="quote-dialog-meta">
          <span>订单 {{ quoteDialog.row.order_no }}</span>
          <span class="quote-meta-gap">币种 {{ quoteDialog.row.currency }}</span>
        </div>
        <el-form size="small" label-width="96px" class="quote-form-top">
          <el-row :gutter="12">
            <el-col :xs="24" :sm="8">
              <el-form-item label="交货天数">
                <el-input-number v-model="quoteDialog.number_days" :min="1" :max="99999" controls-position="right" style="width:100%" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="10">
              <el-form-item label="运费报价">
                <el-input v-model="quoteDialog.logistic_price" clearable @change="normalizeQuoteMoneyField('logistic_price')">
                  <template slot="prepend">{{ (quoteDialog.row && quoteDialog.row.currency) || '' }}</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table :data="quoteDialog.items" :row-key="quoteDialogRowKey" border size="small" max-height="440">
          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="quote-follow-wrap">
                <div v-if="!(props.row.follow_crafts && props.row.follow_crafts.length)" class="quote-follow-empty">无后处理明细</div>
                <el-table v-else :data="props.row.follow_crafts" size="mini" border>
                  <el-table-column label="后处理" min-width="120">
                    <template slot-scope="s">{{ s.row._label || '—' }}</template>
                  </el-table-column>
                  <el-table-column label="数量" width="100">
                    <template slot-scope="s">
                      <el-input-number
                        v-model="s.row.quantity"
                        :min="1"
                        :step="1"
                        size="mini"
                        controls-position="right"
                        style="width:100%"
                        @change="recalcQuoteFollow(props.row)"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column label="单价" width="130">
                    <template slot-scope="s">
                      <el-input v-model="s.row.price" size="mini" @change="recalcQuoteFollow(props.row)" />
                    </template>
                  </el-table-column>
                  <el-table-column label="小计" width="88">
                    <template slot-scope="s">{{ quoteFollowLineSum(s.row) }}</template>
                  </el-table-column>
                  <el-table-column label="附件" min-width="200" show-overflow-tooltip>
                    <template slot-scope="s">
                      <div v-if="s.row._attLinks && s.row._attLinks.length" class="quote-fc-attach">
                        <div v-for="(a, i) in s.row._attLinks" :key="i" class="quote-attach-line">
                          <a v-if="a.url" :href="a.url" target="_blank" rel="noopener" class="quote-attach-link">{{ a.name || a.id }}</a>
                          <span v-else class="quote-attach-name">{{ a.name || a.id }}</span>
                        </div>
                      </div>
                      <span v-else class="muted">—</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="模型文件" min-width="200">
            <template slot-scope="s">
              <div v-if="s.row._fileName || s.row._fileUrl" class="quote-file-cell">
                <div class="quote-file-name">{{ s.row._fileName || '—' }}</div>
                <a v-if="s.row._fileUrl" :href="s.row._fileUrl" target="_blank" rel="noopener" class="quote-file-link">打开文件</a>
              </div>
              <span v-else class="muted">—</span>
            </template>
          </el-table-column>
          <el-table-column label="材料" min-width="140">
            <template slot-scope="s">{{ (s.row.material && s.row.material.material_name) || '—' }}</template>
          </el-table-column>
          <el-table-column label="数量" width="72" prop="quantity" />
          <el-table-column label="行总价(材料+后处理)" min-width="150">
            <template slot-scope="s">
              <el-input
                v-model="s.row.item_total_price"
                size="mini"
                @change="normalizeQuoteItemTotal(s.row)"
                @blur="normalizeQuoteItemTotal(s.row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="后处理合计" width="100">
            <template slot-scope="s">{{ s.row.item_follow_craft_price }}</template>
          </el-table-column>
        </el-table>
        <div class="quote-summary">
          <span>商品合计：{{ quoteSumItemsFormatted }}</span>
          <span class="quote-meta-gap">运费（报价）：{{ quoteDialog.logistic_price }}</span>
          <span class="quote-meta-gap quote-payable">订单总价（含运费）：{{ quotePayableFormatted }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="quoteDialog.visible = false">取消</el-button>
        <el-button type="primary" :loading="quoteDialog.submitting" @click="submitManualQuote">提交报价</el-button>
      </span>
    </el-dialog>

    <!-- 需求1：代建订单对话框 -->
    <el-dialog title="代建订单（报价成交，收款即完结）" :visible.sync="adminCreateDialog.visible" width="720px" :close-on-click-modal="false" append-to-body>
      <el-form size="small" label-width="90px">
        <el-form-item label="客户">
          <el-radio-group v-model="adminCreateDialog.customerMode">
            <el-radio-button label="guest">手填邮箱（轻客户，免登录付款）</el-radio-button>
            <el-radio-button label="existing">选择已有客户（需登录付款）</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <template v-if="adminCreateDialog.customerMode==='existing'">
          <el-form-item label="选择客户">
            <el-select v-model="adminCreateDialog.customerId" filterable remote reserve-keyword
              placeholder="输入邮箱搜索" :remote-method="searchExistingCustomers" :loading="adminCreateDialog.customerLoading" style="width:100%">
              <el-option v-for="cu in adminCreateDialog.customerOptions" :key="cu.id" :label="cu.email + (cu.username ? ' / ' + cu.username : '')" :value="cu.id"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-else>
          <el-row :gutter="12">
            <el-col :span="12">
              <el-form-item label="邮箱" required>
                <el-input v-model="adminCreateDialog.guestEmail" placeholder="customer@example.com"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="名称">
                <el-input v-model="adminCreateDialog.guestName" placeholder="客户名/公司名（选填）"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="币种">
              <el-select v-model="adminCreateDialog.currency" style="width:100%">
                <el-option label="USD" value="USD"></el-option>
                <el-option label="CNY" value="CNY"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="订单备注">
              <el-input v-model="adminCreateDialog.mark" placeholder="选填"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="订单明细">
          <div style="width:100%">
            <div v-for="(it, idx) in adminCreateDialog.items" :key="idx" class="admin-create-item-row">
              <el-input v-model="it.description" placeholder="明细描述，如 CNC Aluminum 6061 x50" style="flex:1;margin-right:8px"></el-input>
              <el-input-number v-model="it.quantity" :min="1" style="width:110px;margin-right:8px"></el-input-number>
              <el-input v-model="it.unit_price" placeholder="单价" style="width:110px;margin-right:8px"></el-input>
              <el-button size="mini" type="danger" icon="el-icon-delete" circle :disabled="adminCreateDialog.items.length<=1" @click="removeAdminCreateItem(idx)"></el-button>
            </div>
            <el-button size="mini" type="primary" plain icon="el-icon-plus" @click="addAdminCreateItem">加一行</el-button>
          </div>
        </el-form-item>
        <div style="text-align:right;font-weight:600">合计：{{ adminCreateDialog.currency }} {{ adminCreateTotalFormatted }}</div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="adminCreateDialog.visible = false">取消</el-button>
        <el-button type="primary" :loading="adminCreateDialog.submitting" @click="submitAdminCreate">创建并发送付款链接</el-button>
      </span>
    </el-dialog>

    <!-- 需求1：改价对话框 -->
    <el-dialog :title="'改价 - ' + (repriceDialog.row ? repriceDialog.row.order_no : '')" :visible.sync="repriceDialog.visible" width="420px" :close-on-click-modal="false" append-to-body>
      <el-form size="small" label-width="90px">
        <el-form-item label="当前总价">
          <span style="font-weight:600">{{ repriceDialog.row ? (repriceDialog.row.currency + ' ' + Number(repriceDialog.row.total_price || 0).toFixed(2)) : '' }}</span>
        </el-form-item>
        <el-form-item label="新总价" required>
          <el-input-number v-model="repriceDialog.totalPrice" :min="0.01" :precision="2" style="width:100%"></el-input-number>
        </el-form-item>
        <el-form-item label="邮件通知">
          <el-switch v-model="repriceDialog.notifyMail" active-text="改价后邮件提醒客户付款"></el-switch>
        </el-form-item>
      </el-form>
      <div style="color:#909399;font-size:12px">仅未付款订单可改价；改价后原付款链接自动失效并刷新。</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="repriceDialog.visible = false">取消</el-button>
        <el-button type="primary" :loading="repriceDialog.submitting" @click="submitReprice">确认改价</el-button>
      </span>
    </el-dialog>

    <!-- 需求7：流转状态邮件开关配置 -->
    <el-dialog title="流转状态邮件配置" :visible.sync="mailStatus.visible" width="480px" append-to-body>
      <div style="color:#909399;font-size:12px;margin-bottom:12px">勾选后，订单流转到该状态时自动给客户发送提醒邮件。</div>
      <el-checkbox-group v-model="mailStatus.checked" v-loading="mailStatus.loading">
        <div v-for="s in mailStatus.all" :key="s.status" style="padding:6px 0">
          <el-checkbox :label="s.status">{{ s.label }}</el-checkbox>
        </div>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mailStatus.visible = false">取消</el-button>
        <el-button type="primary" :loading="mailStatus.saving" @click="saveMailStatusConfig">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import * as XLSX from 'xlsx';
import { mapGetters } from 'vuex'
import ApeUploader from '@/components/ApeUploader'
import { PAY_METHOD_OPTIONS } from '@/constants/payMethods'
import { postBlob } from '@/utils/request'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
    ApeUploader
  },
  data() {
    return {
      payMethodFilterOptions: PAY_METHOD_OPTIONS,
      // 搜索条件
      searchCondition:{
        current_page: 1,
        page_size: 10,
        query: "",
        params: [],
        order_id: '',
        order_no: '',
        merchant_or_trade_no: '',
        order_status: '',
        pay_status: '',
        refund_approve_status: '',
        order_craft_type: '',
        pay_method: '',
        only_pending_sync: false
      },
      orderTimeSort: 'desc',
      syncPayLoading: false,
      loadingStaus: true,
      uploadFileList:[],
      // 表格列表数据
      dataList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        current_page: 1,
        page_size: 10
      },
      // 分页的offset,序号列使用
      offset:0,
      // 表单结构
      formData: {
        avatar:''
      },
      // 表单验证
      rules: {
        order_no: [{required: true,message:'输入订单No', trigger: 'blur' }],
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '权限绑定',
        width_height: '580px',
      },
      rolesList: [],
      userRoles: [],
      // 订单流转对话框
      orderFlowDialog: {
        visible: false,
        loading: false,
        title: '订单流转详情',
        orderInfo: {},
        flowRecords: []
      },
      quoteDialog: {
        visible: false,
        loading: false,
        submitting: false,
        row: null,
        items: [],
        logistic_price: '0.00',
        number_days: 1
      },
      // 需求1：代建订单对话框
      adminCreateDialog: {
        visible: false,
        submitting: false,
        customerMode: 'guest', // 'existing'=选已有客户 'guest'=轻客户
        customerId: '',
        customerKeyword: '',
        customerOptions: [],
        customerLoading: false,
        guestEmail: '',
        guestName: '',
        currency: 'USD',
        mark: '',
        items: [{ description: '', quantity: 1, unit_price: 0 }]
      },
      // 需求1：改价对话框
      repriceDialog: {
        visible: false,
        submitting: false,
        row: null,
        totalPrice: 0,
        notifyMail: true
      },
      // 需求7：流转邮件状态勾选配置
      mailStatus: {
        visible: false,
        loading: false,
        saving: false,
        checked: [],
        all: []
      },
      // 付款页在访客前台域，禁止用 tola/管理域 origin（表 94）。
      // 实测 apex/www 曾 404、tw 可达；tola→tw，生产管理台默认 www（需前台部署 pay_link.html）。
      payLinkBase: (typeof process !== 'undefined' && process.env && process.env.VUE_APP_FRONT_BASE_URL)
        ? String(process.env.VUE_APP_FRONT_BASE_URL).replace(/\/$/, '')
        : (function () {
          try {
            var host = (window.location.hostname || '').toLowerCase()
            if (host.indexOf('tola.') === 0 || host === 'localhost' || host === '127.0.0.1') {
              return 'https://tw.ola3dp.com'
            }
            return 'https://www.ola3dp.com'
          } catch (e) {
            return 'https://www.ola3dp.com'
          }
        })()
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType']),
    quoteSumItemsFormatted() {
      let s = 0
      for (const it of this.quoteDialog.items || []) {
        s += parseFloat(it.item_total_price) || 0
      }
      return s.toFixed(2)
    },
    quotePayableFormatted() {
      const a = parseFloat(this.quoteSumItemsFormatted) || 0
      const b = parseFloat(this.quoteDialog.logistic_price) || 0
      return (a + b).toFixed(2)
    },
    adminCreateTotalFormatted() {
      let s = 0
      for (const it of this.adminCreateDialog.items || []) {
        s += (Number(it.quantity) || 0) * (Number(it.unit_price) || 0)
      }
      return s.toFixed(2)
    }
  },
  methods: {
    // 搜索
    searchButton() {
      this.list()
    },
    async downloadButton() {
      this.setSearchCondition()
      const searchCondition = { ...this.searchCondition }
      delete searchCondition.page_size
      delete searchCondition.current_page
      let res
      try {
        res = await this.$api.post('/service/customer_order/list', searchCondition)
      } catch (e) {
        this.$message.error((e && e.message) || '导出失败')
        return
      }
      if (this.$apiSuccess(res)){
        let data = res.data.list
        const filteredData = data.map(item => {
          const addr = item.Address || {}
          const cust = item.Customer || {}
          const exp = item.Express || {}
          const first = (addr.first_name || cust.firstName || '')
          const last = (addr.last_name || cust.lastName || '')
          const phone = addr.phone_number || cust.mobile || ''
          const addrLine = [addr.country || cust.country, addr.state, addr.city, addr.address].filter(Boolean).join(' ')
          const expressName = item.express_name || exp.express_name || ''
          let flow = item.status_exchange
          if (flow != null && typeof flow === 'object') {
            try { flow = JSON.stringify(flow) } catch (e) { flow = String(flow) }
          } else if (flow != null && typeof flow === 'string') {
            /* keep */
          } else {
            flow = ''
          }
          return {
          "订单编号": item.order_no,
          "订单状态": item.order_status=='0'?'未处理':item.order_status=='1'?'用户确认':item.order_status=='2'?'商户确定':item.order_status=='3'?'生产':item.order_status=='4'?'质检':item.order_status=='5'?'发货':item.order_status=='6'?'签收成功':item.order_status=='7'?'历史状态(旧码7)':item.order_status=='8'?'删除订单':item.order_status=='9'?'取消订单':'',
          "支付状态": item.pay_status=='1'?'等待付款':item.pay_status=='2'?'已付款':item.pay_status=='3'?'申请退款':item.pay_status=='4'?'退款成功':item.pay_status=='5'?'拒绝退款':'',
          "报价类型": this.getOrderCraftTypeText(item.order_craft_type),
          "支付方式": this.getPayMethodText(item.pay_method),
          "转账凭证": item.bank_voucher_url || '',
          "订单流转": flow,
          "币种": item.currency,
          "订单总金额": item.total_price,
          "已付金额": item.pay_amount,
          "折扣": item.discount,
          "订单备注": item.mark,
          "联系人": `${first} ${last}`.trim(),
          "联系电话": phone,
          "收件地址": addrLine,
          "快递公司": expressName,
          "到付账号": item.express_account || '',
          "快递单号": item.express_no,
          "快递费用": item.logistic_price
          }
        })
        const worksheet = XLSX.utils.json_to_sheet(filteredData, {
          header: ['订单编号', '订单状态', '支付状态', '报价类型', '支付方式', '转账凭证', '订单流转', '币种', '订单总金额', '已付金额', '折扣', '订单备注', '联系人', '联系电话', '收件地址', '快递公司', '到付账号', '快递单号', '快递费用']
        });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, '订单数据');
        XLSX.writeFile(workbook, '订单数据.xlsx');
      }
    },
    setSearchCondition() {
      this.searchCondition.query= ''
      this.searchCondition.params = []
      if(this.$route.params.id){
        this.searchCondition.params.push(this.$route.params.id)
        this.searchCondition.query = 'customer_id=?'
      }
      const idKw = (this.searchCondition.order_id != null && this.searchCondition.order_id !== '')
        ? String(this.searchCondition.order_id).trim()
        : ''
      if (idKw !== '') {
        this.setValue('id=?', idKw)
      }
      const noKw = (this.searchCondition.order_no != null && this.searchCondition.order_no !== '')
        ? String(this.searchCondition.order_no).trim()
        : ''
      if (noKw !== '') {
        this.setValue('instr(order_no,?)', noKw)
      }
      this.setValue('order_status=?',this.searchCondition.order_status)
      if (this.searchCondition.pay_method) {
        this.searchCondition.pay_method = this.normalizePayMethod(this.searchCondition.pay_method)
      }
      this.setValue('pay_status=?',this.searchCondition.pay_status)
      this.setValue('refund_approve_status=?', this.searchCondition.refund_approve_status)
      this.setValue('order_craft_type=?',this.searchCondition.order_craft_type)
      if (this.searchCondition.only_pending_sync) {
        this.setValue('pay_status=?', '1')
        this.setValue('order_status<>?', '8')
        this.setValue('order_status<>?', '9')
        this.setValue('pay_order_id<>?', '')
      }
      this.searchCondition.sort = this.orderTimeSort === 'asc' ? 'order_time ASC' : 'order_time DESC'
    },
    toggleOrderTimeSort() {
      this.orderTimeSort = this.orderTimeSort === 'desc' ? 'asc' : 'desc'
      this.searchCondition.current_page = 1
      this.getList()
    },
    // 评审 F16：一键列出待审退款（refund_approve_status=2）
    quickPendingRefund() {
      this.searchCondition.refund_approve_status = '2'
      this.searchCondition.pay_status = ''
      this.searchCondition.current_page = 1
      this.getList()
    },
    setValue(operator, ...values) {
      const value = values.length ? values[0] : ''
      if (value != '' && value != null){
        if (this.searchCondition.query == ''){
          this.searchCondition.query = operator
        }else{
          this.searchCondition.query += ' and '+operator
        }
        values.forEach(v => this.searchCondition.params.push(v))
      }
    },
    // 切换页码操作
    async switchPaging(pagingData) {
      // 更新分页参数
      this.searchCondition.current_page = pagingData.current_page;
      this.searchCondition.page_size = pagingData.page_size;
      // 调用获取数据的方法
      await this.getList();
    },
    // 响应添加按钮
    async addButton() {
      this.uploadFileList=[]
      this.formData = {}
      this.drawerData.visible = true
      this.drawerData.title = '添加订单'
      this.drawerData.loading = false
    },
    // 初始化数据列表
    async getList() {
      this.loadingStaus = true
      this.setSearchCondition()
      try {
        const res = await this.$api.post('/service/customer_order/list', this.searchCondition)
        if (this.$apiSuccess(res)) {
          this.dataList = this.applyClientSideFilters(res.data.list || [])
          this.pagingData.total = res.data.page.total
          this.pagingData.current_page = this.searchCondition.current_page
          this.pagingData.page_size = this.searchCondition.page_size
          this.offset = (this.searchCondition.current_page - 1) * this.searchCondition.page_size
        } else {
          this.$message.error(res.message || '请求失败')
          this.dataList = []
        }
      } catch (e) {
        this.$message.error((e && e.message) || '请求失败')
        this.dataList = []
      } finally {
        this.loadingStaus = false
      }
    },
    // 响应编辑按钮
    async editButton(id) {
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '编辑订单(ID：'+id+')'
      let res = await this.$api.post('/service/customer_order/detail', {id: id})
      if (this.$apiSuccess(res)) {
        this.formData = res.data.result_detail
      } else {
        this.$message.error(res.message)
      }
      this.drawerData.loading = false
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.drawerData.visible = false
      this.drawerData.loading = true
      this.rolesList = []
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['userForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      let res
      if(this.formData.id==undefined){
        res = await this.$api.post('/service/ola_app_customer_order/create', this.formData)
      }else{
        res = await this.$api.post('/service/ola_app_customer_order/update', this.formData)
      }
      
      if (this.$apiSuccess(res)) {
        this.$nextTick(() => {
          this.drawerData.visible = false
        })
        this.$nextTick(async () => {
          this.getList()
        })
        this.$nextTick(() => {
          this.$message.success('保存成功!')
        })
      } else {
        this.$message.error(res.message)
      }
      this.initFormData()
    },
    // row数据提交，请求接口
    async rowSubmit(row) {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      let id = await this.$api.addCustomerOrder(row)
      this.$nextTick(() => {
        this.drawerData.visible = false
      })
      this.$nextTick(async () => {
        if (id) {
          this.list()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
      this.initFormData()
    },
    // 相应删除按钮
    async deleteButton(id) {
      let res = await this.$api.post('/service/ola_app_customer_order/delete', {id: id})
      if (this.$apiSuccess(res)) {
        this.$message.success('删除成功!')
        this.$nextTick(async () => {
          this.getList()
        })
      } else {
        this.$message.error(res.message)
      }
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.formData = {user_role:{system_role_id:0}}
        this.$refs['userForm'].resetFields()
      })
    },
    // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      this.formData.staff_image = file
      this.uploadFileList = fileList
    },
    // 图片删除回调
    handleUploadRemove(file, fileList) {
      this.formData.staff_image = 0
      this.uploadFileList = fileList
    },
    async getCustomerOrderItem(orderNo) {
      // 使用订单号跳转到订单项页面
      this.$router.push(`/customer/order/${orderNo}/customer_order_item`);
    },
    async followButton(id) {
      // 跳转到订单跟进页面
      this.$router.push(`/customer/order-follow/${id}`);
    },
    // 初始化用户列表
    async list() {
      this.loadingStaus=true
      this.setSearchCondition()
      let res= await this.$api.post('/service/customer_order/list',this.searchCondition)
      console.log(res)
      if (this.$apiSuccess(res)){
        this.dataList=this.applyClientSideFilters(res.data.list || [])
        this.pagingData.total = res.data.page.total
        this.pagingData.current_page = this.searchCondition.current_page
        this.pagingData.page_size = this.searchCondition.page_size
        this.offset = (this.searchCondition.current_page - 1) * this.searchCondition.page_size
      }else{
        this.$message.error(res.message)
        this.dataList=[]
        this.loadingStaus=false
        return
      }
      this.loadingStaus=false
    },
    getOrderStatusType(status) {
      if (!status) return 'info';
      const statusTypeMap = {
        '0': 'info',
        '1': 'success',
        '2': 'warning',
        '3': 'info',
        '4': 'info',
        '5': 'success',
        '6': 'success',
        '7': 'info',
        '8': 'danger',
        '9': 'info'
      };
      return statusTypeMap[status] || 'info';
    },
    getOrderStatusText(status) {
      if (!status) return '未知状态';
      const statusTextMap = {
        '0': '未处理',
        '1': '用户确认',
        '2': '商户确定',
        '3': '生产',
        '4': '质检',
        '5': '发货',
        '6': '签收成功',
        '7': '历史状态(旧码7)',
        '8': '删除订单',
        '9': '取消订单'
      };
      return statusTextMap[status] || '未知状态';
    },
    getOrderCustomerEmail(row) {
      if (!row) return '暂无'
      const customerEmail = row.Customer && (row.Customer.email || row.Customer.Email)
      if (customerEmail) return customerEmail
      const addressEmail = row.Address && (row.Address.email || row.Address.Email)
      if (addressEmail) return addressEmail
      return '暂无'
    },
    getOrderCustomerGroupNames(row) {
      if (!row) return '未分组'
      if (row.customer_group_names) return row.customer_group_names
      const g = row.CustomerGroup || row.customer_group
      if (g) {
        const name = g.group_name || g.display_name
        if (name) return name
      }
      return '未分组'
    },
    getOrderCustomerLastOnline(row) {
      if (!row || !row.Customer) return '暂无'
      const loginAt = row.Customer.login_at || row.Customer.LoginAt
      if (!loginAt) return '暂无'
      // 过滤无效零值时间
      const s = String(loginAt)
      if (s.indexOf('0001-01-01') === 0 || s.indexOf('0000-00-00') === 0) return '暂无'
      return this.formatDateTime(loginAt) || '暂无'
    },
    getPayStatusType(status) {
      if (!status) return 'info';
      const statusTypeMap = {
        '1': 'info',
        '2': 'success',
        '3': 'warning',
        '4': 'success',
        '5': 'danger'
      };
      return statusTypeMap[status] || 'info';
    },
    getPayStatusText(status) {
      if (!status) return '未知状态';
      const statusTextMap = {
        '1': '等待付款',
        '2': '已支付',
        '3': '申请退款',
        '4': '退款成功',
        '5': '拒绝退款'
      };
      return statusTextMap[status] || '未知状态';
    },
    normalizePayMethod(method) {
      const normalized = String(method || '').trim().toLowerCase()
      if (normalized === 'bank_transfer' || normalized === 'banktransfer') return 'bank'
      return normalized
    },
    isBankPayMethod(method) {
      return this.normalizePayMethod(method) === 'bank'
    },
    normalizeOrderCraftType(value) {
      const v = String(value == null ? '' : value).trim().toLowerCase()
      if (v === '1' || v === 'auto' || v === 'automatic') return '1'
      if (v === '0' || v === 'manual') return '0'
      return ''
    },
    getOrderCraftTypeText(value) {
      const v = this.normalizeOrderCraftType(value)
      if (v === '1') return '自动报价'
      if (v === '0') return '手动报价'
      return '—'
    },
    getOrderCraftTypeTagType(value) {
      const v = this.normalizeOrderCraftType(value)
      if (v === '1') return 'warning'
      if (v === '0') return 'success'
      return 'info'
    },
    canManualQuote(row) {
      if (!row) return false
      if (this.normalizeOrderCraftType(row.order_craft_type) !== '0') return false
      const st = String(row.order_status)
      if (st !== '0' && st !== '1') return false
      if (String(row.pay_status) !== '1') return false
      return true
    },
    closeQuoteDialog() {
      this.quoteDialog.row = null
      this.quoteDialog.items = []
      this.quoteDialog.logistic_price = '0.00'
      this.quoteDialog.number_days = 1
      this.quoteDialog.submitting = false
    },
    fmtQuoteMoney(v) {
      if (v == null || v === '') return '0.00'
      const n = Number(v)
      if (Number.isFinite(n)) return n.toFixed(2)
      return '0.00'
    },
    parseAttachmentIds(raw) {
      if (!raw) return []
      if (Array.isArray(raw)) return raw.map(String).filter(Boolean)
      if (typeof raw === 'string') {
        try {
          const j = JSON.parse(raw)
          return Array.isArray(j) ? j.map(String).filter(Boolean) : []
        } catch (e) {
          return []
        }
      }
      return []
    },
    quoteFileIdMap(resolvedList) {
      const m = {}
      for (const f of resolvedList || []) {
        if (f && f.id) m[f.id] = f
      }
      return m
    },
    mapOrderItemToQuoteLine(it) {
      const m = it.material || it.Material || {}
      const file = it.File || it.file || {}
      const resolved = it.resolved_attachment_files || it.ResolvedAttachmentFiles || []
      const fileById = this.quoteFileIdMap(resolved)
      const subRaw = it.sub_total_price != null ? it.sub_total_price : it.SubTotalPrice
      const follRaw = it.follow_craft_price != null ? it.follow_craft_price : it.FollowCraftPrice
      const baseRaw = it.base_price != null ? it.base_price : it.BasePrice
      const sub = parseFloat(subRaw) || 0
      const foll = parseFloat(follRaw) || 0
      const baseFromDb = parseFloat(baseRaw) || 0
      const basePart = baseFromDb > 0 ? baseFromDb : Math.max(0, sub - foll)
      const fds = it.FollowCraftDetail || it.followCraftDetail || it.follow_craft_detail || []
      const followCrafts = fds.map((fd) => {
        const fc = fd.FollowCraft || fd.follow_craft || {}
        const ids = this.parseAttachmentIds(fd.attachment_file_ids)
        const _attLinks = ids.map((id) => {
          const f = fileById[id]
          return {
            id,
            name: (f && f.file_name) ? f.file_name : id,
            url: (f && f.file_path) ? f.file_path : ''
          }
        })
        return {
          follow_craft_id: fd.follow_craft_id,
          quantity: fd.quantity != null ? fd.quantity : 1,
          price: this.fmtQuoteMoney(fd.follow_craft_price),
          duration: fd.duration != null ? fd.duration : 0,
          info: fd.info != null ? fd.info : {},
          attachment_file_ids: ids,
          _label: fc.follow_craft_name || '',
          _attLinks
        }
      })
      return {
        id: it.id,
        material_id: it.material_id,
        file_id: it.file_id,
        craft_id: it.craft_id,
        craft_category_id: it.craft_category_id,
        material_color_id: it.material_color_id,
        duration_id: it.duration_id || '',
        quantity: it.quantity,
        attachment_file_ids: this.parseAttachmentIds(it.attachment_file_ids),
        mark: it.mark || '',
        item_base_duration: it.duration,
        item_total_duration: it.total_duration,
        item_total_price: this.fmtQuoteMoney(subRaw),
        item_follow_craft_price: this.fmtQuoteMoney(follRaw),
        follow_crafts: followCrafts,
        material: m,
        _basePart: basePart,
        _fileName: file.file_name || '',
        _fileUrl: file.file_path || ''
      }
    },
    quoteDialogRowKey(row) {
      if (row && row.id) return row.id
      return [row && row.file_id, row && row.material_id, row && row.craft_id, row && row.quantity].join('|')
    },
    async openQuoteDialog(row) {
      if (!this.canManualQuote(row)) return
      this.quoteDialog.row = row
      this.quoteDialog.visible = true
      this.quoteDialog.loading = true
      this.quoteDialog.logistic_price = this.fmtQuoteMoney(row.logistic_price)
      this.quoteDialog.number_days = Math.max(1, parseInt(row.total_duration, 10) || 1)
      try {
        const res = await this.$api.post('/service/customer_order/order_item_list', {
          query: 'order_no=?',
          params: [row.order_no],
          current_page: 1,
          page_size: 500
        })
        if (!this.$apiSuccess(res)) {
          this.$message.error((res && res.message) || '加载订单项失败')
          this.quoteDialog.visible = false
          return
        }
        const list = (res.data && res.data.list) || []
        this.quoteDialog.items = list.map((it) => this.mapOrderItemToQuoteLine(it))
        this.quoteDialog.items.forEach((line) => {
          if (line.follow_crafts && line.follow_crafts.length) {
            this.seedQuoteBasePartFromRowTotal(line)
            this.recalcQuoteFollow(line)
          } else {
            const subFromDb = parseFloat(line.item_total_price) || 0
            const fp = parseFloat(line.item_follow_craft_price) || 0
            const base = Number(line._basePart) || 0
            const combined = base + fp
            if (subFromDb > 0) {
              line.item_total_price = this.fmtQuoteMoney(subFromDb)
            } else {
              line.item_total_price = this.fmtQuoteMoney(combined)
            }
            this.normalizeQuoteItemTotal(line)
          }
        })
      } catch (e) {
        this.$message.error((e && e.message) || '加载订单项失败')
        this.quoteDialog.visible = false
      } finally {
        this.quoteDialog.loading = false
      }
    },
    seedQuoteBasePartFromRowTotal(line) {
      const sub = parseFloat(line.item_total_price) || 0
      const crafts = line.follow_crafts || []
      if (!crafts.length || !(sub > 0)) return
      let sumFollow = 0
      for (const fc of crafts) {
        const q = Number(fc.quantity)
        const qty = Number.isFinite(q) && q > 0 ? q : 1
        sumFollow += (parseFloat(fc.price) || 0) * qty
      }
      const curBase = Number(line._basePart) || 0
      if (curBase <= 0 && sub > sumFollow + 0.001) {
        line._basePart = Math.max(0, sub - sumFollow)
      }
    },
    recalcQuoteFollow(row) {
      const crafts = row.follow_crafts || []
      // 无后处理明细：行总价仅由用户填写或 openQuoteDialog 初始化，不能用 base+0 覆盖（否则 _basePart 未同步时会归零）
      if (!crafts.length) {
        row.item_follow_craft_price = '0.00'
        return
      }
      let sum = 0
      for (const fc of crafts) {
        const q = Number(fc.quantity)
        const qty = Number.isFinite(q) && q > 0 ? q : 1
        fc.quantity = Math.floor(qty)
        sum += (parseFloat(fc.price) || 0) * fc.quantity
      }
      row.item_follow_craft_price = sum.toFixed(2)
      const base = Number(row._basePart) || 0
      row.item_total_price = (base + sum).toFixed(2)
    },
    quoteFollowLineSum(fc) {
      const q = Number(fc.quantity)
      const qty = Number.isFinite(q) && q > 0 ? q : 1
      const a = (parseFloat(fc.price) || 0) * qty
      return a.toFixed(2)
    },
    normalizeQuoteMoneyField(key) {
      this.quoteDialog[key] = this.fmtQuoteMoney(this.quoteDialog[key])
    },
    normalizeQuoteItemTotal(row) {
      row.item_total_price = this.fmtQuoteMoney(row.item_total_price)
      const total = parseFloat(row.item_total_price) || 0
      const fol = parseFloat(row.item_follow_craft_price) || 0
      row._basePart = Math.max(0, total - fol)
    },
    buildQuotationItemsPayload() {
      return (this.quoteDialog.items || []).map((it) => ({
        material_id: it.material_id,
        file_id: it.file_id,
        craft_id: it.craft_id,
        craft_category_id: it.craft_category_id,
        material_color_id: it.material_color_id,
        duration_id: it.duration_id || '',
        quantity: it.quantity,
        attachment_file_ids: it.attachment_file_ids || [],
        mark: it.mark || '',
        item_total_price: String(it.item_total_price != null ? it.item_total_price : '0'),
        item_follow_craft_price: String(it.item_follow_craft_price != null ? it.item_follow_craft_price : '0'),
        item_base_duration: it.item_base_duration != null ? it.item_base_duration : 0,
        item_total_duration: it.item_total_duration != null ? it.item_total_duration : 0,
        follow_crafts: (it.follow_crafts || []).map((fc) => ({
          follow_craft_id: fc.follow_craft_id,
          quantity: fc.quantity,
          price: String(fc.price != null ? fc.price : '0'),
          duration: fc.duration != null ? fc.duration : 0,
          info: fc.info != null ? fc.info : {},
          attachment_file_ids: fc.attachment_file_ids || []
        }))
      }))
    },
    syncQuoteLinesBeforeSubmit() {
      const rows = this.quoteDialog.items || []
      rows.forEach((line) => {
        if (line.follow_crafts && line.follow_crafts.length) {
          this.recalcQuoteFollow(line)
        } else {
          this.normalizeQuoteItemTotal(line)
        }
      })
    },
    /** 行总价须严格大于后处理合计（行总价 = 材料 + 后处理） */
    validateManualQuoteLines() {
      const rows = this.quoteDialog.items || []
      for (let i = 0; i < rows.length; i++) {
        const line = rows[i]
        const total = parseFloat(line.item_total_price) || 0
        const fol = parseFloat(line.item_follow_craft_price) || 0
        if (!(total > fol + 1e-6)) {
          const idx = i + 1
          this.$message.warning(
            `第 ${idx} 行：行总价（材料+后处理）须大于后处理合计；当前行总价 ${total.toFixed(2)}，后处理 ${fol.toFixed(2)}`
          )
          return false
        }
      }
      return true
    },
    async submitManualQuote() {
      const row = this.quoteDialog.row
      if (!row) return
      const nd = Number(this.quoteDialog.number_days)
      if (!(nd > 0)) {
        this.$message.warning('交货天数须大于 0')
        return
      }
      this.syncQuoteLinesBeforeSubmit()
      if (!this.validateManualQuoteLines()) {
        return
      }
      const items = this.buildQuotationItemsPayload()
      if (!items.length) {
        this.$message.warning('没有可提交的订单项')
        return
      }
      let sumBase = 0
      let sumItems = 0
      for (const it of items) {
        const itp = parseFloat(it.item_total_price) || 0
        const ifp = parseFloat(it.item_follow_craft_price) || 0
        sumItems += itp
        sumBase += itp - ifp
      }
      const logistic = parseFloat(this.quoteDialog.logistic_price) || 0
      const orderTotal = sumItems + logistic
      const body = {
        order_id: row.id,
        address_id: row.address_id,
        express_id: row.express_id || '',
        currency: row.currency,
        group_id: row.customer_group_id || '',
        mark: row.mark || '',
        express_name: row.express_name || '',
        express_account: row.express_account || '',
        number_days: Math.floor(nd),
        order_status: String(row.order_status),
        logistic_price: logistic.toFixed(2),
        base_total_price: sumBase.toFixed(2),
        total_price: orderTotal.toFixed(2),
        // 后台手动报价：强制走手动计价校验，避免材料为自动报价工艺时被 VerifyQuotation 按模型重算覆盖行总价
        craft_type: '0',
        items
      }
      this.quoteDialog.submitting = true
      try {
        const res = await this.$api.post('/service/customer_order/update', body)
        if (this.$apiSuccess(res)) {
          this.$message.success('报价已提交')
          this.quoteDialog.visible = false
          this.closeQuoteDialog()
          await this.getList()
        } else {
          this.$message.error((res && res.message) || '提交失败')
        }
      } catch (e) {
        this.$message.error((e && e.message) || '提交失败')
      } finally {
        this.quoteDialog.submitting = false
      }
    },
    getPayMethodType(method) {
      if (!method) return 'info';
      const normalized = this.normalizePayMethod(method)
      const methodTypeMap = {
        'paypal': 'success', // PayPal
        'alipay': 'primary', // 支付宝
        'wechat': 'warning', // 微信
        'visa': 'danger', // 信用卡（Visa / UseePay）
        'bank': 'info' // 银行转账
      };
      return methodTypeMap[normalized] || 'info';
    },
    getPayMethodText(method) {
      if (!method) return '未知支付方式';
      const normalized = this.normalizePayMethod(method)
      const methodTextMap = {
        'paypal': 'PayPal',
        'alipay': '支付宝',
        'wechat': '微信',
        'visa': '信用卡（Visa）',
        'bank': '银行转账'
      };
      return methodTextMap[normalized] || '未知支付方式';
    },
    parsePayInfo(row) {
      if (!row || !row.payinfo) return {}
      if (typeof row.payinfo === 'object') return row.payinfo || {}
      try {
        return JSON.parse(row.payinfo)
      } catch (e) {
        return {}
      }
    },
    extractPaypalOrderId(mark) {
      const text = String(mark || '')
      const flag = 'PayPal订单ID:'
      const idx = text.indexOf(flag)
      if (idx === -1) return ''
      const sliced = text.slice(idx + flag.length).trim()
      if (!sliced) return ''
      return sliced.split('|')[0].trim()
    },
    getTradeNo(row) {
      const payInfo = this.parsePayInfo(row)
      const method = this.normalizePayMethod(row && row.pay_method)
      if (method === 'visa') {
        return payInfo.payment_intent_id || ''
      }
      if (method === 'paypal') {
        return this.extractPaypalOrderId(row && row.mark)
      }
      // 评审 H5：alipay/wechat 查单标识即商户单号（out_trade_no，落库在
      // pay_order_id）——后端 canAdminSyncPaymentStatus 已放行四渠道，
      // 前端 getTradeNo 返回空导致按钮恒不可用，回调丢失后无系统内
      // 恢复路径。此处回退 merchant_order_no 对齐后端判定。
      if (method === 'alipay' || method === 'wechat') {
        return this.getMerchantOrderNo(row)
      }
      return ''
    },
    getMerchantOrderNo(row) {
      const payInfo = this.parsePayInfo(row)
      if (payInfo.merchant_order_id) return payInfo.merchant_order_id
      return (row && row.pay_order_id) || ''
    },
    canSyncPaymentStatus(row) {
      if (!row) return false
      if (String(row.pay_status || '') !== '1') return false
      const os = String(row.order_status || '')
      if (os === '8' || os === '9') return false
      const tradeNo = this.getTradeNo(row)
      const merchantNo = this.getMerchantOrderNo(row)
      return !!(tradeNo && merchantNo)
    },
    applyClientSideFilters(rows) {
      let list = Array.isArray(rows) ? rows : []
      const kw = String(this.searchCondition.merchant_or_trade_no || '').trim().toLowerCase()
      if (kw) {
        list = list.filter((row) => {
          const merchantNo = String(this.getMerchantOrderNo(row) || '').toLowerCase()
          const tradeNo = String(this.getTradeNo(row) || '').toLowerCase()
          return merchantNo.includes(kw) || tradeNo.includes(kw)
        })
      }
      if (this.searchCondition.only_pending_sync) {
        list = list.filter((row) => this.canSyncPaymentStatus(row))
      }
      return list
    },
    async syncOneOrderPaymentStatus(row) {
      if (!row || !row.id) return
      if (!this.canSyncPaymentStatus(row)) {
        this.$message.warning('该订单不满足查单条件（待支付、非取消/关闭、交易号和商户号不为空）')
        return
      }
      this.$set(row, '_syncing', true)
      try {
        const res = await this.$api.post('/service/customer_order/sync_payment_status', { id: row.id })
        if (this.$apiSuccess(res)) {
          const updated = !!(res.data && res.data.updated)
          this.$message.success(updated ? '支付状态已更新' : '支付状态一致，无需更新')
          await this.getList()
        } else {
          this.$message.error(res.message || '查询支付状态失败')
        }
      } catch (e) {
        this.$message.error((e && e.message) || '查询支付状态失败')
      } finally {
        this.$set(row, '_syncing', false)
      }
    },
    async batchSyncPaymentStatus() {
      const candidates = (this.dataList || []).filter((row) => this.canSyncPaymentStatus(row))
      if (!candidates.length) {
        this.$message.warning('当前列表无可查询订单（需待支付、非取消/关闭、交易号和商户号不为空）')
        return
      }
      this.syncPayLoading = true
      try {
        const res = await this.$api.post('/service/customer_order/sync_payment_status_batch', {
          ids: candidates.map((x) => x.id)
        })
        if (this.$apiSuccess(res)) {
          const d = res.data || {}
          this.$message.success(`批量查询完成：总计${d.total || 0}，更新${d.updated || 0}，跳过${d.skipped || 0}，失败${d.failed || 0}`)
          await this.getList()
        } else {
          this.$message.error(res.message || '批量查询失败')
        }
      } catch (e) {
        this.$message.error((e && e.message) || '批量查询失败')
      } finally {
        this.syncPayLoading = false
      }
    },
    orderLineItems (row) {
      if (!row) return []
      const raw = row.Items || row.items
      return Array.isArray(raw) ? raw : []
    },
    // ===== 需求1：代建订单 / 改价 / 付款链接 =====
    canReprice (row) {
      return row && String(row.pay_status) === '1' && !['8', '9'].includes(String(row.order_status))
    },
    canCopyPayLink (row) {
      return row && String(row.pay_status) === '1' && !['8', '9'].includes(String(row.order_status)) && row.pay_link_share
    },
    payLinkUrl (row) {
      const code = row && row.pay_link_share
      if (!code) return ''
      return this.payLinkBase + '/pay_link.html?code=' + code
    },
    async copyPayLink (row) {
      const url = this.payLinkUrl(row)
      if (!url) { this.$message.warning('该订单没有付款链接'); return }
      try {
        await navigator.clipboard.writeText(url)
        this.$message.success('付款链接已复制：' + url)
      } catch (e) {
        this.$prompt('请手动复制付款链接', '付款链接', { inputValue: url, confirmButtonText: '关闭' }).catch(() => {})
      }
    },
    // ===== 需求3：一键形式发票 PDF =====
    async downloadInvoice (row) {
      if (!row || !row.id) return
      this.$set(row, '_invoice', true)
      try {
        const resp = await postBlob('/service/customer_order/invoice', { order_id: row.id })
        const blob = resp && resp.data
        if (!blob) { this.$message.error('发票生成失败'); return }
        // 复审 W1 修复：后端错误走 HTTP 200 + JSON，blob 模式不抛错——
        // 识别 JSON 错误体，避免把错误信息存成损坏 PDF
        if (blob.type && blob.type.includes('application/json')) {
          const text = await blob.text()
          let msg = '发票生成失败'
          try {
            const parsed = JSON.parse(text)
            if (parsed && parsed.message) msg = parsed.message
          } catch (e) { /* keep default */ }
          this.$message.error(msg)
          return
        }
        // 从 Content-Disposition 取发票号文件名，取不到用订单号
        let filename = 'invoice-' + row.order_no + '.pdf'
        const cd = resp.headers && (resp.headers['content-disposition'] || resp.headers['Content-Disposition'])
        if (cd) {
          const m = /filename="?([^";]+)"?/i.exec(cd)
          if (m && m[1]) filename = decodeURIComponent(m[1])
        }
        const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }))
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
        this.$message.success('发票已生成：' + filename)
      } catch (e) {
        this.$message.error((e && e.message) || '发票生成失败')
      } finally {
        // 三审 W1 修复：错误分支提前 return 跳过尾部复位——统一放 finally
        this.$set(row, '_invoice', false)
      }
    },
    openRepriceDialog (row) {
      this.repriceDialog.row = row
      this.repriceDialog.totalPrice = Number(row.total_price) || 0
      this.repriceDialog.notifyMail = true
      this.repriceDialog.visible = true
    },
    async submitReprice () {
      const d = this.repriceDialog
      const newPrice = Number(d.totalPrice)
      if (!(newPrice > 0)) { this.$message.warning('新总价必须大于 0'); return }
      d.submitting = true
      try {
        const res = await this.$api.post('/service/customer_order/admin_update_price', {
          order_id: d.row.id,
          total_price: newPrice,
          notify_mail: d.notifyMail
        })
        if (this.$apiSuccess(res)) {
          this.$message.success('改价成功' + (d.notifyMail ? '，已向客户发送邮件提醒' : ''))
          d.visible = false
          await this.getList()
        } else {
          this.$message.error(res.message || '改价失败')
        }
      } catch (e) {
        this.$message.error((e && e.message) || '改价失败')
      } finally {
        d.submitting = false
      }
    },
    // ===== 需求7：流转状态邮件配置 =====
    async openMailStatusConfig () {
      const d = this.mailStatus
      d.visible = true
      d.loading = true
      try {
        const res = await this.$api.post('/service/customer_order/mail_status_config')
        if (this.$apiSuccess(res)) {
          const data = res.data || {}
          d.all = data.all_statuses || []
          d.checked = (data.enabled_statuses || []).map(String)
        } else {
          this.$message.error(res.message || '加载配置失败')
        }
      } catch (e) {
        this.$message.error((e && e.message) || '加载配置失败')
      }
      d.loading = false
    },
    async saveMailStatusConfig () {
      const d = this.mailStatus
      d.saving = true
      try {
        const res = await this.$api.post('/service/customer_order/mail_status_config_save', { enabled_statuses: d.checked })
        if (this.$apiSuccess(res)) {
          this.$message.success('已保存')
          d.visible = false
        } else {
          this.$message.error(res.message || '保存失败')
        }
      } catch (e) {
        this.$message.error((e && e.message) || '保存失败')
      }
      d.saving = false
    },
    openAdminCreateDialog () {
      const d = this.adminCreateDialog
      d.visible = true
      d.customerMode = 'guest'
      d.customerId = ''
      d.customerKeyword = ''
      d.customerOptions = []
      d.guestEmail = ''
      d.guestName = ''
      d.currency = 'USD'
      d.mark = ''
      d.items = [{ description: '', quantity: 1, unit_price: 0 }]
    },
    addAdminCreateItem () {
      this.adminCreateDialog.items.push({ description: '', quantity: 1, unit_price: 0 })
    },
    removeAdminCreateItem (idx) {
      if (this.adminCreateDialog.items.length <= 1) return
      this.adminCreateDialog.items.splice(idx, 1)
    },
    async searchExistingCustomers (kw) {
      if (!kw || !kw.trim()) { this.adminCreateDialog.customerOptions = []; return }
      this.adminCreateDialog.customerLoading = true
      try {
        const res = await this.$api.post('/service/ola_app_customer/list', {
          current_page: 1,
          page_size: 20,
          // 后端 where 白名单不认 LIKE（security.go 只放行 instr/= 等），LIKE 会被 400
          query: 'instr(email,?)>0',
          params: [kw.trim()]
        })
        if (this.$apiSuccess(res)) {
          this.adminCreateDialog.customerOptions = (res.data && res.data.list) || []
        }
      } catch (e) { /* ignore */ } finally {
        this.adminCreateDialog.customerLoading = false
      }
    },
    async submitAdminCreate () {
      const d = this.adminCreateDialog
      const items = (d.items || []).filter((it) => String(it.description || '').trim() !== '')
      if (!items.length) { this.$message.warning('至少填写一行订单明细'); return }
      for (const it of items) {
        if (!(Number(it.quantity) > 0)) { this.$message.warning('明细数量必须大于 0'); return }
        if (!(Number(it.unit_price) >= 0)) { this.$message.warning('明细单价不能为负'); return }
      }
      if (d.customerMode === 'existing' && !d.customerId) { this.$message.warning('请选择已有客户'); return }
      if (d.customerMode === 'guest' && !String(d.guestEmail || '').trim()) { this.$message.warning('请填写轻客户邮箱'); return }
      d.submitting = true
      try {
        const payload = {
          currency: d.currency,
          mark: d.mark,
          items: items.map((it) => ({
            description: String(it.description).trim(),
            quantity: Number(it.quantity),
            unit_price: Number(it.unit_price)
          }))
        }
        if (d.customerMode === 'existing') payload.customer_id = d.customerId
        else { payload.guest_email = String(d.guestEmail).trim(); payload.guest_name = String(d.guestName || '').trim() }
        const res = await this.$api.post('/service/customer_order/admin_create', payload)
        if (this.$apiSuccess(res)) {
          const detail = (res.data && res.data.detail) || {}
          const link = this.payLinkBase + '/pay_link.html?code=' + (detail.pay_link_code || '')
          this.$alert('订单已创建，付款链接：<br><br><span style="user-select:all;word-break:break-all">' + link + '</span><br><br>系统已向客户发送付款邮件；也可手动复制链接发送。', '代建订单成功', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '好的'
          })
          d.visible = false
          await this.getList()
        } else {
          this.$message.error(res.message || '创建失败')
        }
      } catch (e) {
        this.$message.error((e && e.message) || '创建失败')
      } finally {
        d.submitting = false
      }
    },
    normalizeNestedOne (raw) {
      if (!raw) return null
      if (Array.isArray(raw)) return raw[0] || null
      return raw
    },
    orderItemFileName (it) {
      const f = this.normalizeNestedOne(it && (it.File || it.file))
      if (!f) return '-'
      return f.file_name || f.FileName || '-'
    },
    orderItemCraftName (it) {
      const c = this.normalizeNestedOne(it && (it.Craft || it.craft))
      if (!c) return '-'
      return c.craft_name || c.CraftName || '-'
    },
    /** 工艺细分类名称（如 SLA），来自 CraftCategory.craft_title */
    orderItemCraftCategoryTitle (it) {
      const cc = this.normalizeNestedOne(it && (it.CraftCategory || it.craft_category))
      if (!cc) return ''
      const t = cc.craft_title != null ? cc.craft_title : cc.CraftTitle
      return (t != null && String(t).trim() !== '') ? String(t).trim() : ''
    },
    formatDateTime(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      if (isNaN(date.getTime())) return '';
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    showOrderFlow(row) {
      this.orderFlowDialog.visible = true;
      this.orderFlowDialog.orderInfo = row;
      this.orderFlowDialog.title = `订单流转详情 - ${row.order_no}`;
      this.getOrderFlowRecords(row.id);
    },
    // 获取订单流转记录
    async getOrderFlowRecords(orderId) {
      this.orderFlowDialog.loading = true;
      try {
        // 调用获取订单操作记录的API
        const condition = {
          query: 'order_no=?',
          params: [this.orderFlowDialog.orderInfo.order_no]
        }
        const res = await this.$api.post('/service/ola_app_user_order_follow_record/list', condition)
        console.log('订单操作记录:', res)
        
        if (this.$apiSuccess(res)) {
          const records = res.data.list || []
          // 转换记录格式为流转记录格式
          this.orderFlowDialog.flowRecords = records.map((record, index) => {
            let status = '0'
            let status_name = '未处理'
            let operator = '系统'
            let remark = record.mark || '订单操作'
            
            // 解析变更数据
            if (record.change) {
              try {
                const changeData = JSON.parse(record.change)
                // 获取最新的订单状态
                if (changeData.changed_fields && changeData.changed_fields.order_status) {
                  status = changeData.changed_fields.order_status.to || '0'
                  status_name = this.getOrderStatusText(status)
                }
                // 获取操作员信息
                operator = changeData.operator_email || changeData.operator_id || '系统'
                // 使用变更描述作为备注
                if (changeData.change_descriptions && changeData.change_descriptions.length > 0) {
                  remark = changeData.change_descriptions.join(', ')
                }
              } catch (e) {
                console.error('解析变更数据失败:', e)
              }
            }
            
            return {
              id: record.id || index + 1,
              status: status,
              status_name: status_name,
              operate_time: record.operated_at,
              operator: operator,
              remark: remark
            }
          })
        } else {
          // 如果没有记录，创建默认的订单创建记录
          this.orderFlowDialog.flowRecords = [
            {
              id: 1,
              status: '0',
              status_name: '未处理',
              operate_time: this.orderFlowDialog.orderInfo.created_at,
              operator: '系统',
              remark: `订单创建 (ID: ${orderId})`
            }
          ]
        }
      } catch (error) {
        console.error('获取订单流转记录失败:', error)
        // 创建默认记录
        this.orderFlowDialog.flowRecords = [
          {
            id: 1,
            status: '0',
            status_name: '未处理',
            operate_time: this.orderFlowDialog.orderInfo.created_at,
            operator: '系统',
            remark: `订单创建 (ID: ${orderId})`
          }
        ]
      } finally {
        this.orderFlowDialog.loading = false
      }
    },
    // 关闭订单流转对话框
    closeOrderFlowDialog() {
      this.orderFlowDialog.visible = false;
      this.orderFlowDialog.orderInfo = {};
      this.orderFlowDialog.flowRecords = [];
    },
    // 获取时间轴类型
    getTimelineType(status) {
      if (!status) return 'info';
      const statusMap = {
        '0': 'info',     // 未处理
        '1': 'primary',  // 处理中
        '2': 'success',  // 已完成
        '3': 'warning',  // 暂停
        '4': 'danger'    // 取消
      };
      return statusMap[status] || 'info';
    },
    // 获取时间轴图标
    getTimelineIcon(status) {
      if (!status) return 'el-icon-circle-check';
      const iconMap = {
        '0': 'el-icon-plus',
        '1': 'el-icon-loading',
        '2': 'el-icon-check',
        '3': 'el-icon-warning',
        '4': 'el-icon-close'
      };
      return iconMap[status] || 'el-icon-circle-check';
    },

    // 获取字段标签
    getFieldLabel(fieldName) {
      const fieldLabels = {
        'order_status': '订单状态',
        'pay_status': '支付状态',
        'pay_amount': '已付金额',
        'logistic_price': '快递费',
        'express_name': '快递公司',
        'express_no': '快递单号',
        'discount': '折扣',
        'mark': '备注'
      }
      return fieldLabels[fieldName] || fieldName
    },

    // 格式化变更值
    formatChangeValue(value, fieldName = '') {
      if (value === null || value === undefined || value === '') {
        return '无'
      }
      if (typeof value === 'number') {
        return value.toFixed(2)
      }

      if (fieldName === 'order_status' && this.isOrderStatusField(value)) {
        return this.getOrderStatusText(value)
      }
      if (fieldName === 'pay_status') {
        return this.getPayStatusText(value)
      }

      return String(value)
    },

    // 判断是否为订单状态字段
    isOrderStatusField(value) {
      // 检查是否为订单状态数字
      const statusNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
      return statusNumbers.includes(String(value))
    }
  },
  mounted() {
    const q = this.$route.query.pay_method
    if (q != null && String(q).trim() !== '') {
      this.searchCondition.pay_method = this.normalizePayMethod(String(q))
    }
    this.list()
  },
}
</script>

<style lang="stylus" scoped>
.sortable-order-time-header
  cursor pointer
  user-select none
  i
    margin-left 4px
    font-size 12px

.line-items-preview
  .line-item-row
    display flex
    align-items flex-start
    gap 6px
    margin-bottom 6px
    font-size 12px
    line-height 1.4
    &:last-child
      margin-bottom 0
  .line-item-label
    flex-shrink 0
    color #909399
  .line-item-text
    color #303133
    word-break break-all
.info-value.muted
  color #909399

// 页面标题区域样式
.page-title-section
  background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  border-radius 12px
  padding 24px
  margin-bottom 20px
  color white
  
  .title-content
    .page-title
      margin 0 0 8px 0
      font-size 24px
      font-weight 600
      display flex
      align-items center
      
      i
        margin-right 12px
        font-size 28px
    
    .page-subtitle
      margin 0
      opacity 0.9
      font-size 14px

// 操作面板样式
.action-card
  background white
  border-radius 12px
  padding 16px 20px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .action-buttons
    display flex
    gap 8px

// 搜索卡片样式
.search-card
  background white
  border-radius 12px
  padding 20px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .search-header
    display flex
    align-items center
    margin-bottom 16px
    font-weight 600
    color #303133
    
    i
      margin-right 8px
      color #409eff
  
  .search-content
    .search-form
      margin 0
      
      /deep/ .el-form-item
        margin-bottom 0
        margin-right 16px
      
      /deep/ .el-select
        width 120px

// 表格卡片样式
.table-card
  background white
  border-radius 12px
  padding 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    th
      background #f8f9fa
      color #303133
      font-weight 600
      border-bottom 2px solid #e4e7ed
    
    td
      border-bottom 1px solid #f0f0f0
      padding 12px 8px
    
    tr:hover
      background #f5f7fa

// 序号样式
.sequence-number
  display inline-flex
  align-items center
  justify-content center
  width 24px
  height 24px
  background #409eff
  color white
  border-radius 50%
  font-size 12px
  font-weight 600

// 信息显示样式
.order-info, .address-info, .amount-info, .time-info
  .info-row
    display flex
    align-items center
    margin-bottom 6px
    font-size 12px
    
    i
      color #409eff
      margin-right 6px
      font-size 14px
      width 14px
    
    .info-label
      color #909399
      margin-right 4px
      font-weight 500
      min-width 60px
    
    .info-value
      color #303133
      font-weight 500
      flex 1
      
      &.order-no
        color #409eff
        font-weight 600
        
      &.price, &.total-price
        color #f56c6c
        font-weight 600
        
      &.paid-price
        color #67c23a
        font-weight 600
        
      &.address
        line-height 1.4
        
      &.remark
        line-height 1.4
        color #909399

// 手动报价弹窗
.quote-dialog-meta
  margin-bottom 12px
  font-size 13px
  color #303133
.quote-meta-gap
  margin-left 16px
.quote-form-top
  margin-bottom 4px
.quote-follow-wrap
  padding 8px 20px 12px
  background #fafafa
.quote-follow-empty
  color #909399
  font-size 12px
  padding 4px 0
.quote-summary
  margin-top 12px
  text-align right
  font-size 13px
  color #606266
.admin-create-item-row
  display flex
  align-items center
  margin-bottom 8px
.quote-payable
  font-weight 600
  color #f56c6c
.quote-file-cell
  font-size 12px
  line-height 1.4
.quote-file-name
  word-break break-all
  margin-bottom 4px
.quote-file-link
  font-size 12px
.quote-fc-attach
  font-size 12px
.quote-attach-line
  margin-bottom 2px
.quote-attach-link
  color #409eff
.muted
  color #909399
  font-size 12px

// 操作按钮样式
.action-buttons
  display flex
  gap 6px
  justify-content center
  
  .el-button.is-circle
    padding 6px
    
    &:hover
      transform translateY(-2px)
      transition all 0.3s ease

// 响应式设计
@media (max-width: 768px)
  .page-title-section
    padding 16px
    
    .page-title
      font-size 20px
  
  .search-content
    .search-form
      /deep/ .el-form-item
        margin-right 10px
        margin-bottom 10px
      
      /deep/ .el-select
        width 100px

// 全局样式优化
/deep/ .el-button
  border-radius 6px
  transition all 0.3s ease
  
  &:hover
    transform translateY(-1px)
    box-shadow 0 4px 12px rgba(64, 158, 255, 0.3)

/deep/ .el-input
  .el-input__inner
    border-radius 6px
    transition all 0.3s ease
    
    &:focus
      box-shadow 0 0 8px rgba(64, 158, 255, 0.2)

/deep/ .el-select
  .el-input__inner
    border-radius 6px

/deep/ .el-tag
  border-radius 6px
  font-weight 500
  
  &.el-tag--mini
    padding 2px 6px
    font-size 11px

  .price {
    color: #e6a23c;
    font-weight: 600;
  }
  
  .flow-button {
    color: #409eff;
    font-size: 12px;
    
    &:hover {
      color: #66b1ff;
    }
  }
  
  // 订单流转对话框样式
  .order-flow-content {
    .flow-order-info {
      margin-bottom: 20px;
      
      .info-header {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        
        i {
          margin-right: 8px;
          color: #409eff;
        }
      }
      
      .info-content {
        background: #f8f9fa;
        padding: 15px;
        border-radius: 6px;
        
        .info-item {
          margin-bottom: 10px;
          
          .label {
            color: #606266;
            font-size: 14px;
          }
          
          .value {
            color: #303133;
            font-weight: 500;
            
            &.price {
              color: #e6a23c;
              font-weight: 600;
            }
          }
        }
      }
    }
    
    .flow-records {
      .records-header {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        
        i {
          margin-right: 8px;
          color: #67c23a;
        }
      }
      
      .records-content {
        .record-item {
          .record-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 8px;
            
            .operator {
              color: #909399;
              font-size: 12px;
            }
          }
          
          .record-content {
            .record-remark {
              margin: 0;
              color: #606266;
              font-size: 14px;
              line-height: 1.5;
            }
          }
        }
      }
    }
  }

.order-flow-dialog >>> .el-dialog__wrapper
  display flex !important
  align-items center !important
  justify-content center !important
  min-height 100vh
  z-index 3000
  background rgba(0,0,0,0.18)

.order-flow-dialog >>> .el-dialog
  border-radius 16px
  box-shadow 0 8px 32px rgba(64,158,255,0.18)
  padding 0
  margin 0 auto !important
  max-width 800px
  min-width 320px
  width 90vw
  top 50% !important
  left 50% !important
  transform translate(-50%, -50%) !important
  position relative

.order-flow-content
  padding 0 0 8px 0
  max-height 80vh
  overflow-y auto
  box-sizing border-box
  @media (max-width: 600px)
    padding 0
    max-height 95vh

.card-block
  background #fff
  border-radius 12px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0,0,0,0.08)
  padding 20px 24px
  @media (max-width: 600px)
    padding 10px 6px
    margin-bottom 12px

.timeline-item-block
  margin-bottom 20px
  border-radius 8px
  background #f8f9fa
  box-shadow 0 1px 6px rgba(64,158,255,0.06)
  padding 14px 18px
  position relative
  @media (max-width: 600px)
    padding 8px 4px

  .record-header
    display flex
    align-items center
    justify-content space-between
    margin-bottom 8px
    .operator
      color #909399
      font-size 12px
      margin-left auto
      text-align right

  .record-content
    .record-remark
      margin 0 0 8px 0
      color #606266
      font-size 14px
      line-height 1.5
    .change-details
      margin-top 8px
      .change-item
        display flex
        align-items center
        margin-bottom 4px
        .change-field
          margin-right 8px
        .change-from
          color #909399
          text-decoration line-through
          margin-right 8px
          font-size 12px
        .el-icon-arrow-right
          color #409eff
          margin 0 8px
          font-size 12px
        .change-to
          color #67c23a
          font-weight 500
          font-size 12px

  .record-footer
    display flex
    justify-content flex-end
    .footer-time
      color #bfbfbf
      font-size 12px
      margin-top 4px

.no-records-tip
  text-align center
  color #909399
  font-size 14px
  padding 32px 0
  i
    margin-right 6px
    color #409eff

.dialog-footer
  display flex
  justify-content flex-end
  gap 12px
  flex-wrap wrap
  padding 12px 24px 8px 24px
  @media (max-width: 600px)
    padding 8px 6px 4px 6px
    gap 8px
</style>
